import { useState, useEffect } from 'react';
const BREAKPOINTS = {
    mobile: 365,
    largemobile: 621,
    tablet: 1025,
    desktop: 1441,
};
/**
 * Hook for reactive responsive design detection
 * Updates when window resizes or orientation changes
 *
 * @returns {Object} Object with width and breakpoint booleans
 * @example
 * const { isMobile, width } = useResponsive();
 * if (isMobile) return <MobileNav />;
 */
export const useResponsive = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    return {
        // Current width in pixels
        width,
        // Breakpoint booleans (match tailwind.config.js)
        isMobile: width < BREAKPOINTS.largemobile, // < 621px
        isLargeMobile: width >= BREAKPOINTS.mobile && width < BREAKPOINTS.largemobile, // 365-620px
        isTablet: width >= BREAKPOINTS.largemobile && width < BREAKPOINTS.desktop, // 621-1440px
        isLargeScreen: width >= BREAKPOINTS.desktop, // >= 1441px
        // Utility breakpoints
        isSmallPhone: width < BREAKPOINTS.mobile, // < 365px (edge case)
    };
};
export default useResponsive;
